import * as angular from "angular";
import {sidebar} from "./sidebar/sidebar";
import {groups} from "./groups/groups";
import {assignPrograms} from "./assign-programs/assign-programs";
import {breadcrumbs} from "./common/breadcrumbs/breadcrumbs";

import {paginator} from "./common/paginator/paginator";
import {groupDetail} from "./group-detail/group-detail";
import {defaultGroupDetail} from "./group-detail/default-group-detail";
import {manageDefaults} from "./manage-defaults/manage-defaults";
import {toggle} from "./common/toggle/toggle";
import {modalWindow} from "./common/modal-window/modal-window";
import {setApPrograms} from "./set-ap-programs/set-ap-programs";

export function initComponents(app: angular.IModule) {
    app.directive("sidebar", () => sidebar);
    app.directive("breadcrumbs", () => breadcrumbs);
    app.component("groups", groups);
    app.component("assignPrograms", assignPrograms);
    app.directive("paginator", () => paginator);
    app.component("groupDetail", groupDetail);
    app.component("defaultGroupDetail", defaultGroupDetail);
    app.directive("manageDefaults", () => manageDefaults);
    app.component("toggle", toggle);
    app.directive("modalWindow", () => modalWindow);
    app.directive("setApPrograms", () => setApPrograms);
}



/** WEBPACK FOOTER **
 ** ./~/tslint-loader!./app/app.components.ts
 **/